<template >
  <div>
    <div class="bottom-intend" >
      <CopyText :textToCopy="urlQuiz" class="copy-text-wrapper"/>

      <span class="h4" style="margin-bottom: 15px;">Общее описание психотипа</span>

      <p
        v-for='paragaph in psyTypeText[2]' :key='paragaph'
        class='copy'
      >
        {{paragaph}}
      </p>
    </div>

    <BarGraph :bars="commBarsData" style="margin: 0 auto 150px auto; max-width: 600px;"/>

    <div
      v-for="(bar, i) in commBarsData" :key="i"
      class="bottom-intend"
    >
      <h1 class="h1" style='margin-bottom: 0;'>{{bar.label}}</h1>

      <Header
        :bar="[bar]"
        :points="bar.value"
        :description="skillDescription[bar.name][0]"
        :level="levelName(bar.value)"
      />

      <div v-for="(p, i) in skillDescription[bar.name].slice(1)" :key="p" >
        <span class="h4" style="margin-bottom: 15px;">{{levelNames[i]}}</span>
        <p class="copy">{{p}}</p>
      </div>
    </div>


</div>
</template>

<script>
import { mapState } from 'vuex'
import BarGraph from '@/components/BarGraph'
import Header from './Header'
import CopyText from './CopyText'

export default {
  name: 'QuizResult',
  components: {
    BarGraph,
    Header,
    CopyText
  },
  props: {
    urlQuiz: {
      type: String,
      default: 'LINK LINK LINK LINK LINK LINK LINK'
    },
    commBarsData: {
      type: [Array, Object],
      default: () => [{
          label: 'Включенность',
          name: 'involvement',
          value: 10,
          color: ['#FFDE7F', 'rgba(255, 185, 104, 0.1)'],
        },
      ]
    }
  },
  data() {
    return {
      levelNames: [
        'Низкий',
        'Средний',
        'Высокий 👏'
      ]
    }
  },
  methods: {
    onCopy() {
      this.$message.success('Скопировано')
    },
    point() {
      return Math.floor(Math.random() * 10)
    },
    levelName(point) {
      let lName = ''

      if(point <= 4) {
         lName = this.levelNames[0]
      } else if(point >= 5 && point <= 7 ) {
         lName = this.levelNames[1]
      } else if(point >= 8 && point <= 10 ) {
         lName = this.levelNames[2]
      }

      return lName
    }
  },
  computed: {
    ...mapState({
      psyTypeText: state => state.psyTypeText,
      userUid: state => state.user.uid,
      skillDescription: state => state.communicativeSkillsDescription
    }),
    get(array, value) {
      console.log(array,value)
      return array.filter(o=>o[value]==value)[0]
    }
  }
};
</script>

<style scoped lang='scss'>
@import '../../css/var.scss';

// .wrapper-result {
//   margin: 0 30px;
// }

.h1 {
  @include titleStyles;
  font-size: 48px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
  margin-bottom: 20px;

  @media (max-width: $mobile) {
    font-size: 32px;
    line-height: 1.3;
  }
}

.h4 {
  display: block;
  font-family: $mainFont;
  font-size: 16px;
  color: rgba(black, .5);
  line-height: 100%;
  margin-bottom: 20px;
}

.bottom-intend {
  margin-bottom: 110px
}

.copy-text-wrapper {
  margin-bottom: 20px;
}

// .subtitle {
//   font-family: $mainFont;
//   font-size: 24px;
//   font-weight: 500;
//   line-height: 1.5;
// }

// .loader {
//   position: relative;

//   &-text {
//     text-align: center;
//     display: block;
//     margin-top: 10px;
//     opacity: .7;
//   }
// }

// .link {
//   display: block;
//   margin-bottom: 10px;
// }

// .copy-link {
//   display: block;
// }

</style>
